import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Ok lo Vendo';
const DEFAULT_DESC = 'Compra y vende lo que quieras en Ok lo Vendo — el marketplace de México.';
const DEFAULT_IMAGE = '/assets/oktelovendoligth.png';

/**
 * Drop-in SEO component — sets <title>, OG tags, and Twitter card.
 * Works for ads (type="product") and user profiles (type="profile").
 */
export function SEOMeta({ title, description, image, url, type = 'website' }) {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    const desc = (description || DEFAULT_DESC).slice(0, 300);
    const img = image || DEFAULT_IMAGE;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={desc} />

            {/* Open Graph */}
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={desc} />
            <meta property="og:type" content={type} />
            {img && <meta property="og:image" content={img} />}
            {url && <meta property="og:url" content={url} />}

            {/* Twitter Card */}
            <meta name="twitter:card" content={img ? 'summary_large_image' : 'summary'} />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={desc} />
            {img && <meta name="twitter:image" content={img} />}
        </Helmet>
    );
}
